import { SENTRY_RECEIVE } from '../constants';

const initialState = {
  sentryDsn: window.__litium?.preloadState?.sentryDsn || null,
};

export const sentryDsn = (state = initialState, action) => {
  switch (action.type) {
    case SENTRY_RECEIVE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
